<template>
  <div>
    <div class="page_show">
      <ul class="paging_bar">
        <li>
          <div class="prev_page" @click="prev" v-if="showLeftArrow"></div>
        </li>
        <li :class="1 ==  pageIndex ? 'paging_current' : ''" @click="first">1</li>
        <li class="" v-if="showPrevMore">...</li>
        <li :class="pager ==  pageIndex ? 'paging_current' : ''" v-for="(pager, i) in pagers" :key="i"
          @click="go(pager)">
          {{ pager }}</li>
        <li class="" v-if="showNextMore">...</li>
        <li :class="pages ==  pageIndex ? 'paging_current' : ''" @click="last" v-if="showLastNum">{{pages}}
        </li>
        <li>
          <div class="next_page" @click="next" v-if="showRightArrow"></div>
        </li>
      </ul>
    </div>

    <div class="page_num_show">
      <div class="page_num_box">
        <div class="prev_page" @click="prev" v-if="showLeftArrow"></div>
        <div v-else class="prev_page_null"></div>
        <div class="page_num"><span class="page_num_current">{{pageIndex}}</span>/{{pages}}</div>
        <div class="next_page" @click="next" v-if="showRightArrow"></div>
        <div v-else class="prev_page_null"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paging',
  //通过props来接受从父组件传递过来的值
  props: {
    //页面中的可见页码，其他的以...替代, 必须是奇数
    perPages: {
      type: Number,
      default: 5
    },
    //当前页码
    pageIndex: {
      type: Number,
      default: 1
    },
    //每页显示条数
    pageSize: {
      type: Number,
      default: 10
    },
    //总记录数
    total: {
      type: Number,
      default: 1
    }
  },
  methods: {
    prev () {
      if (this.index > 1 && this.index == this.pageIndex) {
        this.go(this.index - 1)
      }
    },
    next () {
      if (this.index < this.pages && this.index == this.pageIndex) {
        this.go(this.index + 1)
      }
    },
    first () {
      if (this.index !== 1 && this.index == this.pageIndex) {
        this.go(1)
      }
    },
    last () {
      if (this.index != this.pages && this.index == this.pageIndex) {
        this.go(this.pages)
      }
    },
    go (page) {
      let date1 = new Date().getTime()
      if (!this.time || this.time < date1 - 300) {
        this.time = date1
        if (this.index !== page && this.index == this.pageIndex) {
          this.index = page
          //父组件通过change方法来接受当前的页码
          this.$emit('change', this.index)
        }
      }
    }
  },
  computed: {
    //计算总页码
    pages () {
      return Math.ceil(this.size / this.limit)
    },
    //计算页码，当count等变化时自动计算
    pagers () {
      const array = []
      const perPages = this.perPages
      const pageCount = this.pages
      let current = this.index
      const _offset = (perPages - 1) / 2 + 1

      const offset = {
        start: current - _offset,
        end: current + _offset
      }

      //-1, 3
      if (offset.start < 1) {
        offset.end = offset.end + (1 - offset.start)
        offset.start = 1
      }
      if (offset.end > pageCount) {
        offset.start = offset.start - (offset.end - pageCount)
        offset.end = pageCount
      }
      if (offset.start < 1) offset.start = 1

      this.showPrevMore = (offset.start > 1)
      this.showNextMore = (offset.end < pageCount)
      this.showLeftArrow = (current != 1)
      this.showRightArrow = (current != pageCount)
      this.showLastNum = (this.pages != 1)

      for (let i = offset.start + 1; i <= offset.end - 1; i++) {
        array.push(i)
      }

      return array
    }
  },
  data () {
    return {
      index: this.pageIndex, //当前页码
      limit: this.pageSize, //每页显示条数
      size: this.total || 1, //总记录数
      showPrevMore: false,
      showNextMore: false,
      showLeftArrow: false,
      showRightArrow: false,
      showLastNum: true,
      time: undefined,
    }
  },
  watch: {
    pageIndex (val) {
      this.index = val || 1
    },
    pageSize (val) {
      this.limit = val || 10
    },
    total (val) {
      this.size = val || 1
    }
  }
}
</script>

<style scoped>
.paging_bar {
  display: flex;
  height: 38px;
  padding: 0;
  margin: 0 0;
  font-size: 0;
  list-style: none;
  user-select: none;
}
.paging_bar li,
.paging_bar div {
  width: 38px;
  height: 38px;
  font-size: 20px;
  font-family: Helvetica;
  color: rgba(0, 0, 0, 0.65);
  line-height: 38px;
  text-align: center;
  cursor: pointer;
}
.paging_bar li:hover {
  color: #fc5322;
}
.paging_current {
  background: #ffffff;
  border-radius: 2px;
  color: #fc5322 !important;
  border: 1px solid #fc5322;
}
.prev_page {
  background: url("../../assets/paging_bar_left.svg");
}
.prev_page:hover {
  background: url("../../assets/paging_bar_left_hover.svg") no-repeat 9px 8.5px;
}
.next_page {
  background: url("../../assets/paging_bar_right.svg");
}
.next_page:hover {
  background: url("../../assets/paging_bar_right_hover.svg") no-repeat 9px 8.5px;
}
.page_num_show {
  display: none;
}
@media (max-width: 767px) {
  .page_show {
    display: none;
  }
  .page_num_show {
    display: block;
    padding-top: 0.75rem;
  }
  .page_num_box {
    display: flex;
    align-items: center;
  }
  .prev_page,
  .next_page,
  .prev_page_null {
    width: 0.8rem;
    height: 0.8rem;
  }
  .page_num {
    display: flex;
    justify-content: center;
    width: 1rem;
    height: 0.41rem;
    font-size: 0.36rem;
    line-height: 0.41rem;
  }
  .page_num_current {
    color: #fc5322;
  }
  .prev_page:hover .next_page:hover {
    color: #fc5322;
  }
  .paging_bar_current {
    background: #ffffff;
    border-radius: 2px;
    color: #fc5322 !important;
    border: 1px solid #fc5322;
  }
  .prev_page {
    background: url("../../assets/paging_bar_left.svg") no-repeat;
    background-size: 0.8rem;
  }
  .prev_page:hover {
    background: url("../../assets/paging_bar_left_hover.svg") no-repeat 0.19rem
      0.18rem;
    background-size: 0.448rem;
  }
  .next_page {
    background: url("../../assets/paging_bar_right.svg") no-repeat;
    background-size: 0.8rem;
  }
  .next_page:hover {
    background: url("../../assets/paging_bar_right_hover.svg") no-repeat 0.19rem
      0.18rem;
    background-size: 0.448rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/paging.vue